import { TabBarProps } from "../../../shared/components/TabBar";
import TabBar from "../../../shared/components/TabBar";
import ListView from "../../../shared/components/ListView";
import { KpiCategoryTableColumns, KpiRevenueTableColumns } from "../../../configs/kpi";
import { KpiCategoryTable, KpiRevenueCustomTable } from "../CustomTable";

const TabNavigation = () => {
    const tabs: TabBarProps[] = [
        {
            label: "KPI Doanh thu",
            labelEN: "kpi-revenue",
            content: (
                <ListView
                    url={"/kpi/list/?duration_unit=YEAR&type=Revenue"}
                    rowElement={KpiRevenueCustomTable}
                    tableColumns={KpiRevenueTableColumns}
                    textString="Tìm kiếm theo từ khóa Tên chỉ tiêu, Năm"
                />
            ),
        },
        {
            label: "KPI Danh mục",
            labelEN: "kpi-category",
            content: (
                <ListView
                    url={"/kpi/list/?duration_unit=YEAR&type=Category"}
                    rowElement={KpiCategoryTable}
                    tableColumns={KpiCategoryTableColumns}
                    textString="Tìm kiếm theo từ khóa Tên chỉ tiêu, Năm"
                />
            ),
        },
    ];

    return <TabBar tabs={tabs} />;
};

export default TabNavigation;
